import React, { useState } from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { FormControlLabel } from '@material-ui/core';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService';

export const PersonalInjuryPopup = ({ handleClose, handleOpen, handleAgree, isOpen }) => {
    const [checked, setChecked]= useState(false);
    const onAgreeHandler = () => {
        handleAgree();
        handleClose();
        setChecked(false);
    }

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="six-drones-fleet-dialog"
            aria-describedby="six-drones-fleet-dialog">
            <DialogTitle>{FirebaseService.getValue(FirebaseConfigKey.CURRENCY_SYMBOL)}1M Personal Injury Declaration</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    <div className='margin-bottom-basic'>
                        Please read and accept the terms below to proceed.
                    </div>
                    <FormControlLabel
                        // NOTE: Change this input to mui checkbox once reinstalled the packages/upgraded mui since the current version is bearly functional
                        control={<input type="checkbox" checked={checked} style={{transform: 'scale(1.5)', marginRight: '20px'}} onChange={(e) => setChecked(e.target.checked)} />}
                        label="I confirm that if I intend to publish any data or images, I have written procedures in place to help prevent any risk from invasion of privacy"
                    />
                </DialogContentText>
            </DialogContent>
            <DialogActions>
            <Button onClick={handleClose} color="primary">
                Cancel
            </Button>
            <Button disabled={!checked} onClick={onAgreeHandler} color="primary" autoFocus>
                Confirm
            </Button>
            </DialogActions>
        </Dialog>
    );
}